// Фаза Луны на дату (client-side). Синодический месяц ≈ 29.53 сут от опорного
// новолуния. Отдельный модуль: Луна теперь — строка общей легенды карты, своего
// виджета у неё больше нет.
const SYNODIC = 29.53058867
const REF_NEW_MOON = Date.UTC(2000, 0, 6, 18, 14) // 2000-01-06 18:14 UTC

const PHASES = [
  { nameKey: 'maps.moon.new', emoji: '🌑' },
  { nameKey: 'maps.moon.waxingCrescent', emoji: '🌒' },
  { nameKey: 'maps.moon.firstQuarter', emoji: '🌓' },
  { nameKey: 'maps.moon.waxingGibbous', emoji: '🌔' },
  { nameKey: 'maps.moon.full', emoji: '🌕' },
  { nameKey: 'maps.moon.waningGibbous', emoji: '🌖' },
  { nameKey: 'maps.moon.lastQuarter', emoji: '🌗' },
  { nameKey: 'maps.moon.waningCrescent', emoji: '🌘' },
]

/** Фаза на дату: ключ названия, эмодзи и освещённость в процентах. */
export function moonPhase(dateIso: string): { nameKey: string; emoji: string; illumination: number } {
  const t = Date.parse(dateIso + 'T12:00:00Z')
  if (Number.isNaN(t)) return { ...PHASES[0], illumination: 0 }
  const days = (t - REF_NEW_MOON) / 86400000
  const age = ((days % SYNODIC) + SYNODIC) % SYNODIC
  const idx = Math.round(age / SYNODIC * 8) % 8
  const illumination = Math.round((1 - Math.cos((age / SYNODIC) * 2 * Math.PI)) / 2 * 100)
  return { ...PHASES[idx], illumination }
}

